import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class SuggestedattireController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "suggestedattire";
    this.walkthroughState = WALKTHROUGH_STATES.SUGGESTED_ATTIRE;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.arrivalInstructionsSaved = false;

    this.API_FIELDS = "subEvents.deduppedJobbles.id,subEvents.deduppedJobbles.dressCode";

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.saveDressCode();
    });

    this.ArrivalInstructionsSavedListener = this.$rootScope.$on("ArrivalInstructionsSaved", ($event, params) => {
      this.arrivalInstructionsSaved = false;
      this.undisableSaveButton();
      this.setLoader();
    });

    this.$scope.$on("$destroy", this.ArrivalInstructionsSavedListener);
    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);
  }

  $onInit() {
    this.syncWithApi();
    this.blurElement();
  }

  blurElement() {
    this.$timeout(() => {
      $(document.activeElement).blur();
      this.focusEle();
    }, 100);
  }

  focusEle() {
    this.$timeout(() => {
      const el = document.getElementById("job-post-job-sa");
      el.focus();
    }, 100);
  }

  syncWithApi() {
    this.setLoader();
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      this.event.dress_code = data.data.subEvents[0].deduppedJobbles[0].dressCode;
      this.$timeout(() => {
        this.arrivalInstructionsSaved = true;
        this.unSetLoader();
      }, 1000);
    });
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }

  undisableSaveButton() {
    console.log("undisableSaveButtonundisableSaveButton");
    this.$timeout(() => {
      this.arrivalInstructionsSaved = true;
      this.unSetLoader();
    }, 500);
  }

  saveDressCode() {
    this.$events.saveEventDressCode(this.jobble_id, this.event.dress_code).then((data) => {
      this.$tracking.reportPostAJobSubmitStep("suggested attire");
      console.log("Saved suggested attire to event:", data);
    });
  }

  validate() {
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  goNext() {
    this.saveDressCode();
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
  }
}

SuggestedattireController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default SuggestedattireController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/suggestedattire/suggestedattire.controller.js